export default "__VITE_ASSET__DT3H4dIr__"